import classNames from 'classnames'
import { usePwaInstallContext } from '../../context/PwaInstallContext'
import headerStyles from '../header/Header.module.css'
import asideStyles from '../aside-menu/AsideMenu.module.css'
import styles from './PwaInstallButton.module.css'

type PwaInstallButtonProps = {
  variant?: 'header' | 'mobile-menu' | 'mobile-bar' | 'sidebar'
  onClick?: () => void
}

function PwaInstallButton({
  variant = 'header',
  onClick,
}: PwaInstallButtonProps) {
  const { showInstallButton, openInstall } = usePwaInstallContext()

  if (!showInstallButton) {
    return null
  }

  const handleClick = async () => {
    await openInstall()
    onClick?.()
  }

  if (variant === 'sidebar') {
    return (
      <button
        type="button"
        className={classNames(asideStyles.navLink, styles.sidebarBtn)}
        onClick={handleClick}
      >
        <span
          className={classNames(asideStyles.icon, styles.sidebarIcon)}
          aria-hidden="true"
        />
        <span>Скачать</span>
      </button>
    )
  }

  if (variant === 'mobile-menu') {
    return (
      <button
        type="button"
        className={styles.pwaInstallBtnMobile}
        onClick={handleClick}
      >
        Скачать приложение
      </button>
    )
  }

  if (variant === 'mobile-bar') {
    return (
      <button
        type="button"
        className={classNames(
          headerStyles.btnBlueOutline,
          headerStyles.btnSmall,
          headerStyles.btnMobile,
          styles.mobileBarBtn
        )}
        onClick={handleClick}
        title="Установить приложение"
        aria-label="Установить приложение"
      >
        <span className={styles.mobileBarIcon} aria-hidden="true" />
      </button>
    )
  }

  return (
    <button
      type="button"
      className={classNames(styles.headerInstallBtn, 'd-none d-lg-inline-flex')}
      onClick={handleClick}
      title="Установить приложение"
    >
      <span className={styles.headerInstallIcon} aria-hidden="true" />
      <span>Установить</span>
    </button>
  )
}

export default PwaInstallButton
